var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['step-title', { 'is-disabled': _vm.isDisabled, 'has-slot-content': _vm.$slots.default }]},[_c('div',{staticClass:"step-title__title-wrapper"},[_c('CircleNumber',{staticClass:"step-title__number",attrs:{"value":_vm.number}}),_c('h2',{staticClass:"step-title__title"},[_vm._v(_vm._s(_vm.text))])],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }